import { CargaProps } from '../interfaces/carga-props';

export const useSettlementDelete = (props: CargaProps) => {
  const remove = async (liqins_id: string, onSuccess?: () => void) => {
    try {
      props.changeBlockUI(true);

      await props.system.getSettlementSystem().deleteSettlement(liqins_id);

      props.courier.messageSuccess('Insumo eliminado correctamente');

      onSuccess?.();
    } catch (error) {
      props.courier.messageError(error);
    } finally {
      props.changeBlockUI(false);
    }
  };

  return { remove };
};
